export default {
  title: 'Nova máscara',
  title_edit: 'Editando máscara',
  help: 'Ajuda',
  howToTitle: 'Como criar padrões de máscaras',
  forNumbers: 'Para números',
  forLetters: 'Para letras',
  forAlphanumeric: 'Para alfanumericos',
  name: 'Nome*',
  pattern: 'Máscara*',
  playground: 'Playground',
  applied: '(aplicado: {{pattern}})'
}
